// 공용 푸터 — 전자상거래법 초기화면 표시사항 (약관 v5.0 ⑤)
// 통신판매업 신고번호: 2026-10-19 발급(제2026-경기김포-6350호) → 10-28 기입. 비어 있으면 줄 자체를 표시하지 않음(10-04~10-27 미신고 기간은 비워 둠)
//   ("신고 준비 중"·"미신고" 같은 임시 문구 금지 — 허위·불리 표기 방지, 계획 §4-7)
import React from 'react';
import { useNavigate } from 'react-router-dom';

// 상호·대표 — 결제 화면 사업자 정보 줄(AppSubscription, 계획_가입승인결제흐름 W8)도 이 상수를 쓴다
export const COMPANY_NAME = '주식회사 덴탈클러스터';
export const CEO_NAME = '김승우';
export const BIZ_NUMBER = '318-81-11805';
// 사업장 주소 — 전자상거래법 초기화면 표시사항(대표 확인 2026-09-16). 다른 화면도 이 상수를 쓴다
export const BIZ_ADDRESS = '경기도 김포시 태장로 846 한강센트럴자이2단지 204동 602호'; // 대표 확정 2026-10-06: 846 (사업자등록증 기준 — 토스 심사 반송으로 856 오기 정정, 종전 09-22 값 856)
// 공용 연락처 상수 — 계정 삭제 안내(/account/delete) 등 다른 화면도 이 값을 쓴다. 이메일은 PrivacyPolicy.js:688과 동일 주소
export const CONTACT_PHONE = '010-2972-3733'; // 공식 문의처 통일 (2026-10-04 대표 결정)
export const CONTACT_EMAIL = 'dentcluster@gmail.com';
export const ECOM_REPORT_NO = '제2026-경기김포-6350호';    // 통신판매업 신고번호 — 김포시 2026-10-19 발급(신고일 10-16), 법인 318-81-11805 명의(공정위 조회 확인 10-28). 신고증: 사업자료/정부24 - 통신판매업신고 : 문서출력.pdf
const HOSTING_PROVIDER = 'Google LLC'; // 호스팅서비스 제공자 (Firebase Hosting) — 전자상거래법 초기화면 표시사항

function SiteFooter() {
    const navigate = useNavigate();
    return (
        <footer style={{ borderTop: '1px solid #E5E7EB', background: '#F9FAFB', padding: '20px 16px', marginTop: 40 }}>
            <div style={{ maxWidth: 960, margin: '0 auto', fontSize: 12, color: '#9CA3AF', lineHeight: 1.8 }}>
                <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 6 }}>
                    <button onClick={() => navigate('/terms')} style={btnStyle}>이용약관</button>
                    <button onClick={() => navigate('/privacy')} style={btnStyle}>개인정보처리방침</button>
                </div>
                <div>
                    {COMPANY_NAME} · 대표 {CEO_NAME} · 주소 {BIZ_ADDRESS} · 문의 {CONTACT_PHONE} · 이메일 {CONTACT_EMAIL}
                    {BIZ_NUMBER && <> · 사업자등록번호 {BIZ_NUMBER}</>}
                    {ECOM_REPORT_NO && <> · 통신판매업신고 {ECOM_REPORT_NO}</>}
                    {' · 호스팅서비스 제공자 '}{HOSTING_PROVIDER}
                </div>
                <div style={{ marginTop: 4 }}>
                    주식회사 덴탈클러스터는 매칭·중개 서비스에서 통신판매중개자이며 거래의 당사자가 아닙니다.
                    상품·용역의 거래 책임은 각 판매 회원에게 있습니다.
                </div>
            </div>
        </footer>
    );
}
const btnStyle = { background: 'none', border: 'none', padding: 0, color: '#6B7280', fontSize: 12, cursor: 'pointer', textDecoration: 'underline' };
export default SiteFooter;
